import httpManager from "@/app/shared/utils/httpManager";

export async function fetchRegenerationFilters(strategy) {
  const url = `/strategies/${strategy}/available-field-regeneration/`;
  const response = await httpManager.get(url);
  return response.data;
}
